export class FieldSyncUpdateAssetCommand {
    constructor(context, asset) {
        this.context = context;
        this.asset = asset;
    }
}
//# sourceMappingURL=field-sync-update-asset.command.js.map